export const DARK_TOOLTIP_PROPS = {
  componentsProps: {
    tooltip: {
      sx: {
        backgroundColor: '#292929',
        color: '#fff',
        fontSize: 10,
        fontWeight: 500,
        maxWidth: 180,
        borderRadius: '6px',
        px: 0.75,
        py: 0.5
      }
    },
    arrow: { sx: { color: '#292929' } }
  }
}

export const SMOOTH_ICON_SX = {
  lineHeight: 1,
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
}
